import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IFile } from '../files/file.interface';

declare const $: any;
const self: any = null;

@Component({
  selector: 'app-file-view-modal',
  templateUrl: './file-view-modal.component.html',
  styleUrls: ['./file-view-modal.component.css']
})
export class FileViewModalComponent {
  dialog: MatDialogRef<any>;
  file!: IFile;

  constructor(
    public dialogRef: MatDialogRef<any>
  ) {
    this.dialog = dialogRef;
  }

  ngOnInit () {
    // $(document).ready(function () { $("#viewer").click(function () { this.requestFullscreen() }) });
  }
}